import React, { createContext, useContext, useState, useEffect } from "react";
import API from "../services/api";
const AuthContext = createContext(null);
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("lv_user")); } catch { return null; }
  });
  const [isConfigured, setIsConfigured] = useState(false);
  const [loading, setLoading] = useState(true);
  const [branding, setBranding] = useState(() => {
    try { return JSON.parse(localStorage.getItem("lv_branding")) || {}; } catch { return {}; }
  });

  useEffect(() => {
    const token = localStorage.getItem("lv_token");
    if (token) {
      API.get("/auth/me")
        .then(({ data }) => {
          // Preserve avatar_url from localStorage if backend hasn't returned it yet
          const stored = JSON.parse(localStorage.getItem("lv_user") || "{}");
          const merged = { ...stored, ...data.user };
          setUser(merged);
          setIsConfigured(data.isConfigured);
          localStorage.setItem("lv_user", JSON.stringify(merged));
          // Load branding
          API.get("/settings/branding").then(({ data: b }) => {
            setBranding(b);
            localStorage.setItem("lv_branding", JSON.stringify(b));
          }).catch(() => {});
        })
        .catch(() => {
          localStorage.removeItem("lv_token");
          localStorage.removeItem("lv_user");
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const signin = async (email, password) => {
    const { data } = await API.post("/auth/signin", { email, password });
    localStorage.setItem("lv_token", data.token);
    localStorage.setItem("lv_user", JSON.stringify(data.user));
    setUser(data.user);
    setIsConfigured(data.isConfigured);
    return data;
  };
  const signup = async (formData) => {
    const { data } = await API.post("/auth/signup", formData);
    localStorage.setItem("lv_token", data.token);
    localStorage.setItem("lv_user", JSON.stringify(data.user));
    setUser(data.user);
    setIsConfigured(false);
    return data;
  };
  const signout = () => {
    localStorage.removeItem("lv_token");
    localStorage.removeItem("lv_user");
    localStorage.removeItem("lv_branding");
    setUser(null);
    setIsConfigured(false);
    setBranding({});
  };
  const updateBranding = (b) => {
    setBranding(b);
    localStorage.setItem("lv_branding", JSON.stringify(b));
    // Apply accent color CSS variable
    if (b.accent_color) {
      document.documentElement.style.setProperty("--color-teal", b.accent_color);
    }
  };
  const updateUser = (u) => {
    const merged = { ...user, ...u };
    setUser(merged);
    localStorage.setItem("lv_user", JSON.stringify(merged));
  };

  // Apply branding on load
  useEffect(() => {
    if (branding?.accent_color) {
      document.documentElement.style.setProperty("--color-teal", branding.accent_color);
    }
    if (branding?.favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
      link.href = branding.favicon;
    }
  }, [branding]);

  return (
    <AuthContext.Provider value={{ user, isConfigured, setIsConfigured, loading, signin, signup, signout, branding, updateBranding, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};
export const useAuth = () => useContext(AuthContext);
